import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsUnsubscribeRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports-unsubscribe',
	path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
	exact: true,
};
